import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import axiosInstance from "../../../api/axios";
import dayjs from 'dayjs';
import TransactionTable from "../table/TransactionTable";
import { notifySuccess, notifyError } from "../../../components/common/toast/ToastFunc";

const AuthorizeTransaction = (props) => {

  const { isReviewTransaction, isTransactionHistory } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {
      const formattedData = data.map(item => {
        return {
          ...item,
          id: item.id.replace(/-/g, ''),
          from_acc: item.from_acc.replace(/-/g, ''),
          to_acc: item.to_acc.replace(/-/g, ''),
          amount: `$ ${item.amount}`,
          created_at: dayjs(item.created_at).format('MM/DD/YYYY HH:mm:ss'),
          status: item?.status.charAt(0).toUpperCase() + item?.status.slice(1).toLowerCase(),
          type: item?.type.charAt(0).toUpperCase() + item?.type.slice(1).toLowerCase()
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError("Something went wrong");
    }
  }, []);

  const approveTransaction = useCallback(async (transaction_id) => {
    try {
      setActionLoading(true);
      const response = await axiosInstance.post('/transaction/approve-transaction', { transaction_id });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch]);

  const rejectTransaction = useCallback(async (transaction_id) => {
    try {
      setActionLoading(true);
      const response = axiosInstance.post('/transaction/reject-transaction', { transaction_id });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch]);

  const reviewTransaction = useCallback(async (transaction_id) => {
    try {
      setActionLoading(true);
      const response = await axiosInstance.post('/transaction/review-transaction', { transaction_id });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch]);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const url = isReviewTransaction ? '/transaction/get-pending' : isTransactionHistory ? '/transaction/get-authorized' : '/transaction/get-all';
        const response = await axiosInstance.get(url);
        formatData(response.data?.data);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFetch]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>{isReviewTransaction ? "Review Transaction" : isTransactionHistory ? "Transaction History" : "Authorize Transaction"}</Typography>
      <TransactionTable
        data={data}
        setData={setData}
        loading={loading}
        actionLoading={actionLoading}
        setReFetch={setReFetch}
        approveTransaction={approveTransaction}
        rejectTransaction={rejectTransaction}
        reviewTransaction={reviewTransaction}
        isReviewTransaction={isReviewTransaction}
        isTransactionHistory={isTransactionHistory}
      />
    </Box>
  );
};

export default AuthorizeTransaction;